<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <strong>Зонирование</strong>
                    </CCardHeader>
                    <AppTabLinks :links="tabLinks" class="mx-4 mt-2" />
                    <CCardBody>
                        <div class="table__preloader" v-if="loading">
                            <CSpinner color="primary"/>
                        </div>
                        <div class="table__preloader" v-else-if="!zones.length">
                            Для настройки тарифов необходимо распределить башни по зонам
                        </div>
                        <template v-else>
                            <template v-for="(item, paramsIndex) in params">
                                <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4" :key="item.id">
                                    <CRow>
                                        <CCol sm="3">
                                            <CSelect
                                                v-model="item.delivery_zone_from_id"
                                                label="Откуда"
                                                :options="zoneOptions"
                                                outlined
                                                hide-details
                                            />
                                        </CCol>
                                        <CCol sm="3">
                                            <CSelect
                                                v-model="item.delivery_zone_to_id"
                                                label="Куда"
                                                :options="zoneOptions"
                                                outlined
                                                hide-details
                                            />
                                        </CCol>
                                        <CCol sm="3">
                                            <CInput v-model="item.price" label="Стоимость доставки (руб)" />
                                        </CCol>
                                        <CCol sm="3">
                                            <CInput v-model="item.time" label="Время доставки (мин)" />
                                        </CCol>
                                        <CCol sm="6" class="flex-center">
                                            <div class="form-check form-switch flex-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    label="Стоимость доставки"
                                                    :checked.sync="item.enabled"
                                                />
                                                <label class="form-check-label ml-2">Активен</label>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" class="flex-end">
                                            <CButton
                                                color="danger"
                                                @click="removeParams(paramsIndex)"
                                            ><CIcon
                                                :content="$options.icons.cilTrash"
                                            /></CButton>
                                        </CCol>
                                    </CRow>
                                </div>
                            </template>
                        </template>
                    </CCardBody>

                    <CCardFooter>
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="save"
                        >Сохранить</CButton>
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="addParams"
                        >Добавить тариф</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import { cilTrash } from '@coreui/icons';
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        name: 'DemandsList',

        components: {
            AppTabLinks,
        },

        icons: {
            cilTrash
        },

        computed: {
            zoneOptions() {
                return [{
                    label: "Не выбрано",
                    value: null
                }].concat(this.zones.map(item => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                }))
            }
        },

        data() {
            return {
                tabLinks: [
                    {
                        title: 'Зоны',
                        url: `/delivery-zones`,
                    },
                    {
                        title: 'Тарифы',
                        url: `/delivery-zones/params`,
                    },
                ],
                loading: true,
                zones: [],
                params: [],
                deletedParamsIds: []
            };
        },

        async created() {
            await Promise.all([this.fetchZones(), this.fetchParams()]);
            this.loading = false;
        },

        methods: {
            async fetchZones() {
                const response = await this.axios.get('/delivery-zones');
                this.zones = response.data;
            },
            async fetchParams() {
                const response = await this.axios.get('/delivery-zones/params');
                this.params = response.data;
            },
            addParams() {
                this.params.push({
                    delivery_zone_from_id: null,
                    delivery_zone_to_id: null,
                    price: "0.00",
                    time: 0,
                    enabled: true
                });
            },
            removeParams(paramsIndex) {
                if(this.params[paramsIndex].id) {
                    this.deletedParamsIds.push(this.params[paramsIndex].id);
                }
                this.params.splice(paramsIndex, 1);
            },
            async save() {
                this.loading = true;

                for(const id of this.deletedParamsIds) {
                    await this.axios.delete(`/delivery-zones/params/${id}`);
                }

                for(const item of this.params) {
                    if(item.id) {
                        await this.axios.put(`/delivery-zones/params/${item.id}`, item);
                    } else {
                        await this.axios.post(`/delivery-zones/params`, item);
                    }
                }

                await this.fetchParams();
                this.loading = false;
                this.$root.$emit('showAlert', 'Изменения успешно сохранены');
            }
        },
    };
</script>

<style>
    .flex-end {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
    }
    .flex-center {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .tower-line {
        display: flex; 
        justify-content: space-between; 
        align-items: center;
    }
    .tower-border {
        margin: 3px -11px;
        padding: 5px 5px 5px 10px;
        border: 1px solid #d8dbe0;
        border-radius: 0.25rem;
    }
</style>